import { render, staticRenderFns } from "./notarizationResult.vue?vue&type=template&id=53a7230f&scoped=true"
import script from "./notarizationResult.vue?vue&type=script&lang=js"
export * from "./notarizationResult.vue?vue&type=script&lang=js"
import style0 from "./notarizationResult.vue?vue&type=style&index=0&id=53a7230f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a7230f",
  null
  
)

export default component.exports